import React, { FC } from 'react';
import clsx from 'clsx';
// import { text } from '../../../text';
import { Typography } from '@npm-registry/eapteka-ui';
import { Icon } from './Icon';
import { RecipeLabelProps } from './types';
import styles from './RecipeLabel.scss';

export const RecipeLabel: FC<RecipeLabelProps> = ({
  className,
  title
  // description = text['recipeLabel.description']
}) => {
  return (
    <div className={clsx([styles.root, className])}>
      <Icon className={styles.icon} />
      <Typography className={styles.title} variant="p2">
        {/* <span className={styles.description}>{description}</span><br/> */}
        {title}
      </Typography>
    </div>
  );
};
